export const FromString = {
    /**
     * Copy string to clipboard.
     * Only works in browser environments — silently does nothing in Node.js.
     * @param textToCopy Text to copy.
     */
    copyToClipboard(textToCopy: string): void {
        if (typeof navigator === "undefined") return;
        navigator.clipboard.writeText(textToCopy);
    },
    /**
     * Replace the first N characters with the given string.
     * Does not mutate — returns a new string.
     * @param n First N characters to replace (starts from 1)
     * @param w Replacement string (must have length === n)
     * @param str Input string
     */
    replaceFirst(n: number, w: string, str: string): string {
        try {
            if (n !== w.length) throw "Length of replacement and target slot must be equal.";
            return `${w}${str.slice(n)}`;
        } catch (err) {
            console.log(`FromString.replaceFirst: ${err}`);
            return "";
        }
    },
    /**
     * Replace the last N characters with the given string.
     * Does not mutate — returns a new string.
     * @param n Last N characters to replace (starts from 1)
     * @param w Replacement string (must have length === n)
     * @param str Input string
     */
    replaceLast(n: number, w: string, str: string): string {
        try {
            if (n !== w.length) throw "Length of replacement and target slot must be equal.";
            return `${str.slice(0, str.length - n)}${w}`;
        } catch (err) {
            console.log(`FromString.replaceLast: ${err}`);
            return "";
        }
    },
    /**
     * Parse an HTTP cookie string into a key/value object.
     * @param cookie Raw cookie string
     */
    parseCookies(cookie: string): Record<string, string> {
        const list: Record<string, string> = {};
        cookie.split(";").forEach((part) => {
            const parts = part.split("=");
            const key = parts.shift()?.trim();
            if (key) list[key] = decodeURI(parts.join("="));
        });
        return list;
    },
    /**
     * Remove all whitespace, symbols, and special characters.
     * Leaves only 0–9 and a–Z.
     * @param str Input string
     */
    deepClean(str: string): string {
        return str.trim().replace(/[^0-9a-zA-Z]/g, "");
    },
    /**
     * Count occurrences of a word within a string.
     * @param str Input string.
     * @param wordToCount Word to count.
     * @param isolated Only count when the word appears as a standalone word (space-bounded).
     */
    count(str: string, wordToCount: string, isolated: boolean = false): number {
        if (isolated) return str.split(` ${wordToCount} `).length - 1;
        return str.split(wordToCount).length - 1;
    },
};
